import axios from 'axios';
import spinnerBlackList from './spinnerBlackList';
import store from "../store/store";
import {startLoader2, stopLoader2} from '../store/actions/requestAction';

const instance = axios.create({
    //baseURL: "/api/flota"
    baseURL: "https://qsafe24.com.pl/api/flota"
});

export let requestCount = 0;

const startLoaderConditionally = count => count > 0 && store.dispatch(startLoader2());
const stopLoaderConditionally = count => count === 0 && store.dispatch(stopLoader2());

instance.interceptors.request.use(function (config) {
    if (!isInBlackList(spinnerBlackList, config))
        requestCount++;
    startLoaderConditionally(requestCount);
    return config;
}, function (error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    if (!isInBlackList(spinnerBlackList, response.config))
        requestCount--;
    stopLoaderConditionally(requestCount);
    return response;
}, function (error) {
    if (!isInBlackList(spinnerBlackList, error.config))
        requestCount--;
    stopLoaderConditionally(requestCount);
    return Promise.reject(error);
});

export const isInBlackList = (list, config) => {
    return Boolean(list.find(element => element.url === config.url && element.method === config.method));
};

export default instance;
